import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadingBox from "../../../../../components/LoadingBox";
import { CALENDAR_ID, selectPlan } from "../../../constants";
import { planOpActions } from "../../../reducer";
import styles from '../style.module.scss';


export default function Loading() {
    const loadingData = useSelector(selectPlan.loadingVessels);
    const loadingLazy = useSelector(selectPlan.loadingLazy);
    const [position, setPosition] = useState({
        top: 0,
        height: 0,
        left: 0,
        right: 0,
    });

    const dispatch = useDispatch();

    const [mode, setMode] = useState(0);

    const onScroll = useCallback((e: any) => {
        if (loadingLazy || !e.target)
            return;

        const { scrollLeft, scrollWidth, clientWidth, offsetWidth, clientHeight } = e.target;
        const { top, left } = e.target.getBoundingClientRect();
        setPosition({
            height: clientHeight - 45,
            top: top + 45,
            left,
            right: left + clientWidth,
        });
        const action = () => setMode(0);
        setMode(prev => {
            if (scrollLeft === 0) {
                setTimeout(() => dispatch(planOpActions.lazyLoadingRequest({ key: 'beforeCount', action })), 100)
                return 1
            } else if (scrollLeft + offsetWidth >= scrollWidth) {
                setTimeout(() => dispatch(planOpActions.lazyLoadingRequest({ key: 'afterCount', action })), 100)
                return 2;
            } else if (prev !== 0)
                return 0;

            return prev;
        })
    }, [loadingLazy, dispatch]);

    useEffect(() => {
        const el = document.getElementById(CALENDAR_ID);
        if (!el)
            return;
        const { clientWidth, clientHeight } = el;
        const { top, left } = el.getBoundingClientRect();
        setPosition({
            height: clientHeight - 45,
            top: top + 45,
            left,
            right: left + clientWidth,
        });
        el.addEventListener('scroll', onScroll);
        return () => {
            el.removeEventListener('scroll', onScroll);
        }
    }, [onScroll]);

    return <>
        {(loadingLazy && mode === 1) && <div className={styles.loading} data-position='left'
            style={{ left: `${position.left + 160}px`, top: `${position.top}px`, height: `${position.height}px` }}>
            <LoadingBox loading={true} />
        </div >}
        {loadingData && <div className={styles.loading} data-position='center'
            style={{ left: `${position.left}px`, top: `${position.top}px`, height: `${position.height}px`, right: `${position.right}px` }}
        >
            <LoadingBox loading={true} />
        </div>}
        {(loadingLazy && mode === 2) && <div className={styles.loading} data-position='right'
            style={{ top: `${position.top}px`, height: `${position.height}px`, left: `${position.right - 110}px` }}>
            <LoadingBox loading={true} />
        </div>}
    </>;
};